import {FuseLoadable} from '@fuse';

export const organisationsConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes  : [
        {
            path     :"/app/organization/manageOrganization" ,
            component: FuseLoadable({
                loader: () => import('./organisations')
             
            })
        },
      
       
      

    ]
};

